import { render, staticRenderFns } from "./PgaDropdownSearch.vue?vue&type=template&id=3f758bcd&"
import script from "./PgaDropdownSearch.vue?vue&type=script&lang=ts&"
export * from "./PgaDropdownSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f758bcd')) {
      api.createRecord('3f758bcd', component.options)
    } else {
      api.reload('3f758bcd', component.options)
    }
    module.hot.accept("./PgaDropdownSearch.vue?vue&type=template&id=3f758bcd&", function () {
      api.rerender('3f758bcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaDropdownSearch.vue"
export default component.exports